import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfo } from '@/types/user';
import { EngineerZoneInfo } from '@/types/user';
import CookieUtil from '@/utils/cookies';

type Location = { latitude: number; longitude: number };

interface UserState {
  token: string | null;
  userInfo: UserInfo | null;
  isAuthenticated: boolean;
  latitude: number | null;
  longitude: number | null;
  engineerZoneInfo: EngineerZoneInfo | null;
}

const getInitialLocation = () => {
  try {
    const loc = JSON.parse(localStorage.getItem('location') || 'null');
    if (loc && typeof loc.latitude === 'number' && typeof loc.longitude === 'number') {
      return { latitude: loc.latitude, longitude: loc.longitude };
    }
  } catch {}
  const latStr = localStorage.getItem('latitude');
  const lngStr = localStorage.getItem('longitude');
  return {
    latitude: latStr ? Number(latStr) : null,
    longitude: lngStr ? Number(lngStr) : null,
  };
};

const initialLocation = getInitialLocation();

const initialState: UserState = {
  token: localStorage.getItem('token') || null,
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null') || null,
  isAuthenticated: !!localStorage.getItem('token'),
  latitude: initialLocation.latitude,
  longitude: initialLocation.longitude,
  engineerZoneInfo: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      state.userInfo = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
    },
    setEngineerZoneInfo: (state, action: PayloadAction<EngineerZoneInfo>) => {
      state.engineerZoneInfo = action.payload;
      console.log(state,11111,state.engineerZoneInfo)
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem('token', action.payload);
    },
    setLocation: (state, { payload: { latitude, longitude } }: PayloadAction<Location>) => {
      //debugger;
      state.latitude = latitude;
      state.longitude = longitude;
      localStorage.setItem('location', JSON.stringify({ latitude, longitude }));
      localStorage.removeItem('latitude');
      localStorage.removeItem('longitude');
    },
    logout: (state) => {
      //退出登录
      state.token = null;
      state.userInfo = null;
      state.isAuthenticated = false;
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('vipTempMiles');
      // localStorage.removeItem('location');
      CookieUtil.remove('token');
      CookieUtil.remove('userInfo');
    },
  },
});

export const { setUserInfo, setToken, setLocation, logout,setEngineerZoneInfo } = userSlice.actions;
export default userSlice.reducer; 